<template>
	<div class="row">
		<div class="col-md-4 offset-md-4">
			<div class="card">
				<div class="card-body text-center">
					<div class="mb-2">
						<img src="@/assets/img/kmib-logo.png" class="w-25" />
					</div>
					<div class="mb-3">
						<strong>KMIB EDU Editor</strong>
					</div>
					<h4 class="mb-3">
						<strong class="text-uppercase">{{$t('header.cp')}}</strong>
					</h4>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'KMIB EDU Editor'});
	},
	data: () => ({
		
	}),
	methods: {},
	mounted(){
		this.appModel.pageTitle = 'title.cp';
		
		window.scrollTo(0, 0);
	},
	beforeMount(){
		if(this.authModel.isAuth()){
			if(this.authModel.isAdmin()){
				this.$router.push({path: '/admin'});
			} else if(this.authModel.isStudent()){
				this.$router.push({path: '/'});
			}
		}
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
};
</script>